import React from 'react';
import { Link } from 'react-router-dom';
import Card from './Card';
import Button from './Button';
import { PublicProjectDto } from '../../services/api';

interface ProjectCardProps {
  project: PublicProjectDto;
}

const projectImages = ['/images/project-0.svg', '/images/project-1.svg', '/images/project-2.svg'];

const ProjectCard: React.FC<ProjectCardProps> = ({ project }) => {
  const imageIndex = project.id
    .split('')
    .reduce((sum, char) => sum + char.charCodeAt(0), 0) % projectImages.length;
  const imageSrc = projectImages[imageIndex];

  return (
    <Card className="project-card">
      <img src={imageSrc} alt={`${project.title} project illustration`} className="project-card-image" />
      <div>
        <div className="badge">Active Delivery</div>
        <h3 style={{ margin: '1rem 0 0.5rem' }}>{project.title}</h3>
        <p style={{ color: 'var(--color-muted)', margin: 0 }}>{project.location}</p>
      </div>
      <p style={{ color: 'var(--color-muted)', lineHeight: 1.75 }}>{project.summary}</p>
      <div style={{ marginTop: 'auto' }}>
        <Button as={Link} to={`/portfolio/${project.id}`} variant="secondary">
          View project details
        </Button>
      </div>
    </Card>
  );
};

export default ProjectCard;
